import { render } from "./App.vue?vue&type=template&id=4616c76d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4616c76d&lang=css"

import exportComponent from "/Users/roniggs/Desktop/Grad School/Spring 2024/PGDV 5210 - Major Studio/Coding Sessions/major-studio-2-sp24_PF/maj_studio_thesis/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__